// ------------------------------------------------------------------
// PURE MODULE: svgfuns.mod.js
// ------------------------------------------------------------------

export function MakeSvgEl(name, attrs) {
    const el = document.createElementNS("http://www.w3.org/2000/svg", name);
    
    for (const key in attrs) {
        if (key === "textContent") {
            el.textContent = attrs[key];
        } else {
            el.setAttributeNS(null, key, attrs[key]);
        }
    }
    
    return el;
}